"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureActiveDirectoryAppRegistrationTokenProvider = void 0;
const qs = require("querystring");
const axios_1 = require("axios");
const token_1 = require("./token");
const guard_1 = require("../utils/guard");
const utils_1 = require("../resilience/utils");
const tokenProviderError_1 = require("./tokenProviderError");
/**
 * Token provider for an Azure Active Directory App Registration.
 */
class AzureActiveDirectoryAppRegistrationTokenProvider {
    /**
     * Initializes a new instance of the @see AzureActiveDirectoryAppRegistrationTokenProvider class.
     * @param baseUrl The base URL for the token endpoint, e.g. 'https://login.microsoftonline.com'.
     * @param clientId The Id of the application registration.
     * @param clientSecret The secret for the application registration.
     * @param tenantId  The Id of the Azure Active Directory tenant.
     * @param logger Logger to use.
     */
    constructor(baseUrl, clientId, clientSecret, tenantId, logger) {
        guard_1.Guard.throwIfNullOrEmpty(baseUrl, 'baseUrl');
        guard_1.Guard.throwIfNullOrEmpty(clientId, 'clientId');
        guard_1.Guard.throwIfNullOrEmpty(clientSecret, 'clientSecret');
        guard_1.Guard.throwIfNullOrEmpty(tenantId, 'tenantId');
        this.requestOptions = {};
        this.requestOptions.baseURL = baseUrl;
        this.requestOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
        this.request = qs.stringify({
            client_id: clientId,
            scope: `${clientId}/.default`,
            client_secret: clientSecret,
            grant_type: 'client_credentials',
        });
        this.tenantId = tenantId;
        this.clientId = clientId;
        this.logger = logger;
    }
    /**
     * Gets an access token.
     * @param requestId Request Guid.
     * @returns An access token.
     */
    getToken(requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.trace(requestId, `Requesting token for Azure Ad App ${this.clientId} in Tenant ${this.tenantId}`, null, utils_1.logFormatter);
            try {
                const response = yield axios_1.default.post(`${this.tenantId}/oauth2/v2.0/token`, this.request, this.requestOptions);
                const aadToken = response.data;
                const expires = new Date();
                expires.setSeconds(expires.getUTCSeconds() + aadToken.expires_in);
                this.logger.trace(requestId, `Token for Azure Ad App ${this.clientId} received, valid until ${expires.toUTCString()}`, null, utils_1.logFormatter);
                return new token_1.Token(aadToken.access_token, expires);
            }
            catch (e) {
                const message = `Error requesting Token for Azure Ad App ${this.clientId}`;
                this.logger.error(requestId, message, e, utils_1.logFormatter);
                throw new tokenProviderError_1.TokenProviderError(message, e);
            }
        });
    }
}
exports.AzureActiveDirectoryAppRegistrationTokenProvider = AzureActiveDirectoryAppRegistrationTokenProvider;
//# sourceMappingURL=azureAdAppRegistrationTokenProvider.js.map